// Widget Scripts
import hotButtons from './js/widgets/hotButtons.js';
import mainFeatureSlide from './js/widgets/mainFeatureSlide.js';
import seoWidget from './js/widgets/seoWidget.js';
import cardwidgetevents from './js/widgets/cardWidgetEvents.js';
import sponsorwidgetcontainer from './js/widgets/cssSponsors.js';
import footerEmail from './js/widgets/cardWidgetEmail.js';
import footerContact from './js/widgets/cardWidgetContact.js';
import footerlogo from './js/widgets/footerLogo.js';
import cardWidgetvideo from './js/widgets/cardWidgetVideo.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    hotButtons();
    seoWidget();
    cardWidgetvideo();
    mainFeatureSlide();
    cardwidgetevents();
    sponsorwidgetcontainer();
  });
}

$(document).ready(function () {
  footerEmail();
  footerContact();
  footerlogo();
});
